/* eslint-disable jsx-a11y/anchor-is-valid */
import {enqueueSnackbar} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import Swal from 'sweetalert2'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {getBedsService} from '../../../bed/services'
import {deleteBedService} from '../../../bed/services/deleteBed.service'
import {BedModel} from '../../models'
import {ModalNewBed} from '../Modal/ModalNewBed'
import {ModalUpdateBed} from '../Modal/ModalUpdateBed'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableBeds: FC = () => {
  const {data, setData, setPagination, loading, setLoading, selected, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const [showModalNew, setShowModalNew] = useState(false)
  const [bedToEdit, setBedToEdit] = useState<BedModel | any>(null)
  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const getBeds = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBedsService({
        HabitacionId: currentTabItem.idToEdit,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getBeds()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getBeds()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<BedModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Habitación' />,
      accessor: 'Habitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Cama' />,
      accessor: 'Codigo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Descripción' />,
      accessor: 'Descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama Caliente' />,
      accessor: 'CamaCaliente',
      Cell: ({...props}) => <div>{props.row.original.CamaCaliente ? 'SI' : 'NO'}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('CAMAS/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const mappedSelected = selected.map((item) => ({Id: item}))
        const {data: response} = await deleteBedService(mappedSelected)
        if (!response.error) {
          getSnackBarToast('Se eliminó satisfactoriamente', 'success')
          getBeds()
        } else {
          getSnackBarToast(response.message, 'error')
        }
        getBeds()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }
  const handleEdit = (item: BedModel) => {
    setBedToEdit(item)
    setShowModalUpdate(true)
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      {isAllowed('CAMAS/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('CAMAS/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('CAMAS/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selected.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <ModalUpdateBed
            show={showModalUpdate}
            setShow={setShowModalUpdate}
            bedToEdit={bedToEdit}
            getBeds={getBeds}
          />
          {showModalNew ? (
            <ModalNewBed show={showModalNew} setShow={setShowModalNew} getBeds={getBeds} />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableBedsFromRoomWrapper = () => {
  return (
    <KTableProvider>
      <TableBeds />
    </KTableProvider>
  )
}
export {TableBedsFromRoomWrapper}
